export const matchAlphabetsOnly = /^[a-zA-Z\s]+$/;
export const matchZeroDecimal = /^\d+$/;
export const matchSingleDecimalsOnly = /^\d+(\.\d{1})?$/;
export const matchTwoDecimalsOnly = /^\d+(\.\d{1,2})?$/;
export const matchThreeDecimalsOnly = /^\d+(\.\d{1,3})?$/;
export const matchTwoDigitsOnly = /^\d{1,2}(?:\.\d+)?$/;
export const matchThreeDigitsOnly = /^\d{1,3}$/;
export const matchFiveDigitsOnly = /^\d{1,5}(?:\.\d+)?$/;
export const matchSixDigitsOnly = /^\d{1,6}(?:\.\d+)?$/;
export const threeDigitAndThreeFloat = /^(100(\.0{1,3})?|[0-9]\d{0,1}(\.\d{0,3})?)$/;
export const matchFourDigitAndFourFloat = /^(\d{1,4}(\.\d{0,4})?|(\.\d{1,4}))$/;
export const threeDigitAndFourFloat = /^(100(\.0{1,3})?|[0-9]\d{0,1}(\.\d{0,4})?)$/;
export const threeDigitAndTwoFloat = /^(100(\.0{1,3})?|[0-9]\d{0,1}(\.\d{0,2})?)$/;
export const matchFiveDigitsAndTwoFloat = /^([0-9]\d{0,4}(\.\d{0,2})?)$/;
export const matchSevenDigitsOnly = /^\d{1,7}(?:\.\d+)?$/;
export const matchNineDigitsOnly = /^\d{1,9}(?:\.\d+)?$/;
export const websiteURLRegex = /^((http|https):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;
export const specialCharacterExceptHyphenRegex = /^[a-zA-Z\s-]+$/;
export const alphaNumericWithoutSpecialCharacterAndSpace = /^[a-zA-Z0-9-]+$/;
export const matchCNICRegex = /^[0-9+]{5}-[0-9+]{7}-[0-9]{1}$/;
export const matchAlphaNumericRegex = /^[a-zA-Z0-9\s-]+$/;
// eslint-disable-next-line no-useless-escape
export const urlFileNameExtractorRegex = /\/([^\/]+)$/; // Extracts the last part after the last slash
